import React from "react";
import {
  Slide,
  Button,
  Box,
  TextField,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useState } from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { ApplicationState } from "../../store";
import * as APIStore from "../../store/APIStore";
import { Send, Cancel } from "@material-ui/icons";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ErrorIcon from "@material-ui/icons/Error";
import { useHistory } from "react-router-dom";
import RequestAccessToken from "../../util/authService";
import NotificationPatient from "./NotificationPatient";

import "../style.css";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from '@material-ui/core/styles';


type NotificationComposeProps = APIStore.HNIContextState &
  typeof APIStore.actionCreators &
  RouteComponentProps<{ receiverId: string }>;


const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  input: {
    display: 'none',
  },
}));

const NotificationCompose = (props: NotificationComposeProps) => {
  let {

    submitNewMessageWithAttachment,
    Messages,
    clearMessageState,

  } = props;

  let FocusPatient: APIStore.Patient = props?.FocusPatient?.patient;
  let location = props.location;
  let PatientPhysiciansContacts = props.PatientPhysiciansContacts;


  let newInitialState: APIStore.Message = {subject : `Patient: ${FocusPatient.lastName}`};
  let [tokenState, setTokenState] = useState(null);
  let [physicianSelectionState, setPhysicianSelectionState] = useState<APIStore.HNIProviderContact>();
  const [newMessageState, setNewMessageState] = useState(newInitialState);

  let tokenStatePr = RequestAccessToken().then((token) => {
    if (token && !tokenState) {
      setTokenState(token);
    }
  });

  let { state } = location;

  let PatientPhysicians = PatientPhysiciansContacts.userPatientContacts;

  const classes = useStyles();

  let isErrored, error, message = null;

  let receiverId = null;
  if (state) {
    ({ receiverId } = state);
  }

  let messageError = "";
  let SendMessageState = Messages.SendMessageState;
  if (SendMessageState) {
    let { isErrored, error, message } = SendMessageState;
  }
  if (isErrored) {
    messageError = error;
  }

  if (receiverId && (!physicianSelectionState?.email)) {
    debugger;
      let physicianSelectionTemp = PatientPhysicians.filter(
        (val) => val.email === receiverId
      )[0];

      if(physicianSelectionTemp) {
        setPhysicianSelectionState(physicianSelectionTemp);

        setNewMessageState({
          ...newMessageState,
          receiverId: receiverId
        });
      }   
  }

  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };

  const handleMessageChange = (e: any) => {
    setNewMessageState({
      ...newMessageState,
      Message: e.target.value,
    });
  };

  const handleSubjectChange = (e: any) => {
    setNewMessageState({
      ...newMessageState,
      subject: e.target.value,
    });
  };

  const handleSend = () => {
    sendFormAndFileState();
    goBack();
  };

  const handleErrorClose = () => {
    clearMessageState();
  };

  const handleFileSelectChange = (e: any) => {
    let file = e.target.files[0];
    let fileName = file.name;

    setNewMessageState({
      ...newMessageState,
      document: file,
      documentFileName: fileName
    });
  }

  const sendFormAndFileState = () => {
    const formData = new FormData();
    for (var key in newMessageState) {
      if (key !== "Document") {
        formData.append(key, newMessageState[key])
      }
    }

    formData.append("PtId", FocusPatient.patientEncounterId)
    formData.append("Document", newMessageState.document)
    formData.append("DocumentFileName", newMessageState.documentFileName)

    submitNewMessageWithAttachment(formData, tokenState.accessToken)
  }

  const handleReceiverChange = (e: any) => {
    let physicianSelectionTemp = PatientPhysicians.filter(
      (val) => val.email === e.target.value
    )[0];

    if(physicianSelectionTemp) {
      setPhysicianSelectionState(physicianSelectionTemp);    
    }

    setNewMessageState({
      ...newMessageState,
      receiverId: e.target.value
    });
  };



  

  if (!physicianSelectionState || !physicianSelectionState?.email) {
    return (<React.Fragment></React.Fragment>);
  }

  return (
    <Slide in timeout={800} direction="left">
      <div>
        <Grid container spacing={8} className="noticebar">
          <Grid item>
            <Button onClick={handleSend} startIcon={<Send />}>
              <Hidden xsDown>Send</Hidden>
            </Button>
            <Button onClick={goBack} startIcon={<Cancel />}>
              <Hidden xsDown>Cancel</Hidden>
            </Button>
          </Grid>
        </Grid>
        <Box m={4}>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={4}
          >
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="standard">
                <InputLabel id="demo-simple-select-label">To:</InputLabel>
                <Select
                  value={physicianSelectionState.email}
                  onChange={(e) => {handleReceiverChange(e)}}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="To:"
                >
                  {PatientPhysicians.map((val) => {
                    if (val.type.includes('Program')) {
                      return (
                        <MenuItem value={val.email}>
                          {val.displayName} - {val.type}
                        </MenuItem>
                      );
                    } else {
                      return (
                        <MenuItem value={val.email}>
                          {val.displayName}
                        </MenuItem>
                      );
                    }

                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid direction="row" item xs={12} sm={12}>

              <Grid item xs={4} sm={4}>
                <TextField
                  id="compose-message-subject"
                  onChange={handleSubjectChange}
                  value={newMessageState.subject}
                  label="Subject"
                  variant="standard"
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <NotificationPatient message={newMessageState} />
              </Grid>


            </Grid>

            <Grid item xs={12}>
              <TextField
                id="compose-message-box"
                label="Message"
                multiline
                onChange={handleMessageChange}
                rows={4}
                value={newMessageState.Message}
                defaultValue=""
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>


              <FormControl>
                <input
                  className={classes.input}
                  accept=""
                  onChange={handleFileSelectChange}
                  id="contained-button-file"
                  multiple
                  type="file"
                />
                <label htmlFor="contained-button-file">
                  <Button variant="outlined" component="span">
                    {
                      newMessageState.documentFileName ? newMessageState.documentFileName : "Upload Document"
                    }
                  </Button>
                </label>
              </FormControl>

            </Grid>
          </Grid>

        </Box>
        <Snackbar
          className="red-snackbar"
          message={`Error sending message: ${messageError}`}
          open={isErrored}
          action={
            <React.Fragment>
              <Button color="secondary" size="small" onClick={() => handleErrorClose()}>
                CLOSE
              </Button>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleErrorClose}
              >
                <ErrorIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
        />
      </div>
    </Slide>
  );
};

export default connect(
  (state: ApplicationState) => state.vitalsContext,
  APIStore.actionCreators
)(NotificationCompose as any);
